export * from './People1XIcon';
export * from './People1XIcon16Light';
export * from './People1XIcon16Regular';
export * from './People1XIcon16Solid';
export * from './People1XIcon20Light';
export * from './People1XIcon20Regular';
export * from './People1XIcon20Solid';
export * from './People1XIcon24Regular';
export * from './People1XIcon24Solid';
export * from './People1XIcon32Regular';
export * from './People1XIcon64Regular';
